var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5965 4.80475C18.9531 4.80475 19.25 5.10083 19.25 5.47758V5.82591C19.25 6.19349 18.9531 6.49873 18.5965 6.49873H3.40437C3.04687 6.49873 2.75 6.19349 2.75 5.82591V5.47758C2.75 5.10083 3.04687 4.80475 3.40437 4.80475H6.0771C6.62003 4.80475 7.09253 4.41884 7.21466 3.87434L7.35463 3.24918C7.57216 2.39761 8.28804 1.83203 9.10733 1.83203H12.8927C13.703 1.83203 14.427 2.39761 14.6365 3.20427L14.7862 3.87343C14.9075 4.41884 15.38 4.80475 15.9238 4.80475H18.5965ZM17.2387 17.5382C17.5177 14.9377 18.0063 8.7594 18.0063 8.69706C18.0241 8.50823 17.9626 8.32948 17.8404 8.18557C17.7094 8.05082 17.5436 7.97107 17.3608 7.97107H4.64614C4.46249 7.97107 4.28776 8.05082 4.16651 8.18557C4.04349 8.32948 3.98286 8.50823 3.99178 8.69706C3.99342 8.70852 4.01095 8.92614 4.04026 9.28998C4.17045 10.9063 4.53307 15.408 4.76739 17.5382C4.93321 19.1075 5.9629 20.0939 7.45439 20.1296C8.60532 20.1562 9.79103 20.1654 11.0035 20.1654C12.1455 20.1654 13.3053 20.1562 14.4919 20.1296C16.0351 20.103 17.0639 19.1341 17.2387 17.5382Z",
    fill: "#D9272D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.0247d0baa8d26e1babf7a9a3902ddde1.svg";
export { ForwardRef as ReactComponent };